import React from 'react';
import { observer } from 'mobx-react';
import Gallery from 'react-photo-gallery';
import { EmptyListMessage } from 'components';
import Modal from 'react-modal';
import { Link } from 'react-router-dom';

@observer
class PaperworkEntryImageList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentImage: 0,
            lightboxIsOpen: false
        };

        this.closeLightbox = this.closeLightbox.bind(this);
        this.openLightbox = this.openLightbox.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.getImage = this.getImage.bind(this);
    }

    openLightbox(event, obj) {
        this.setState({
            currentImage: obj.index,
            lightboxIsOpen: true,
        }, () => {
            this.getImage(obj.index)
        });
    }
    closeLightbox() {
        this.setState({
            currentImage: 0,
            lightboxIsOpen: false,
        });
    }
    handleChange({ newIndex }) {
        this.setState({
            currentImage: newIndex
        }, () => {
            this.getImage(newIndex)
        });
    }
    getImage(idx) {
        const image = this.props.images[idx];
        if (!image.promiseResult && image.promise) {
            image.promise();
        }
    }

    render() {
        if (!this.props.images || this.props.images.length === 0) {
            return <EmptyListMessage message={"There are no images for this paperwork entry"} />
        }
        return (
            <div>
                <ObserverGallery photos={this.props.images.peek()} columns={6} onClick={this.openLightbox} ImageComponent={Photo}>
                </ObserverGallery>
                <PaperworkLightbox images={this.props.images.peek()}
                    onClose={this.closeLightbox}
                    onChange={this.handleChange}
                    activeIndex={this.state.currentImage}
                    isOpen={this.state.lightboxIsOpen}
                >
                </PaperworkLightbox>
            </div>
        )
    }
}


const ObserverGallery = observer((props) => { return <Gallery {...props} /> })
const imgWithClick = { cursor: 'pointer' };

@observer
class Photo extends React.Component {
    constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(event) {
        const { onClick, index, photo } = this.props;
        onClick(event, { photo, index });
    }

    render() {
        const { photo, onClick, margin } = this.props;
        const { loading, width, height, url } = photo;
        const imgStyle = { display: 'block', float: 'left', margin: margin };
        return (
            <div className="box__img-holder__wrap">
                {
                    <div className="box__img-holder box__img-holder--med spc--bottom--med">    
                        <img className="modal__thumbnail--img"
                            style={onClick ? { ...imgStyle, ...imgWithClick } : imgStyle}
                            width={width}
                            height={height}
                            src={url}
                            onClick={onClick ? this.handleClick : null}
                        />
                    </div>
                    
                }
                <Link className="btn btn--med btn--primary spc--bottom--med" to={`/paperwork/image/${photo.id}`}> Edit </Link>
            </div>
        );
    }
}

@observer
class PaperworkLightbox extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            data: {}
        };

        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.downloadImage = this.downloadImage.bind(this);
        this.base64toBlob = this.base64toBlob.bind(this);
    }

    handleChange(newIndex) {
        this.props.onChange({
            newIndex: newIndex
        })
    }

    afterOpenModal() {
        //this.setupImage();
    }

    closeModal() {
        this.props.onClose();
    }


     base64toBlob(dataURI) {
        var byteString = atob(dataURI.split(',')[1]);
        var ab = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(ab);
    
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: 'image/jpeg' });
    }


    downloadImage() {
        var image = this.getCurrentImage();
        var fileName = image.id + '.png';
        var blob = this.base64toBlob(image.promiseResult.data, "application/image");

        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
    } 

    render() {
        const {
            isOpen,
            activeIndex
        } = this.props;

        const {
            data
        } = this.state;

        const image = this.getCurrentImage();
        const loading = image.loading;

        const imageCount = this.props.images.length;
        const showPrev = !loading && imageCount > 1 && activeIndex !== 0;
        const showNext = !loading && imageCount > 1 && activeIndex !== imageCount - 1;
        return (
            <Modal
                isOpen={isOpen}
                onAfterOpen={this.afterOpenModal}
            >
                
                {showPrev ? <span className="modal__prev" onClick={() => this.handleChange(this.props.activeIndex - 1)}><div className="modal__chevron-left"></div></span> : null}
                <button className="btn--close" onClick={this.closeModal}>
                    <a href="#" className="modal__close"></a>
                </button>
                {loading ? <span><div className="modal__loader">
                                    <div className="modal__loader--inner">
                                        <label>	●</label>
                                        <label>	●</label>
                                        <label>	●</label>
                                        <label>	●</label>
                                        <label>	●</label>
                                        <label>	●</label>
                                    </div>
                                </div>
                            </span> : (image && image.promiseResult && image.promiseResult.data ? 
                            <span>
                            <img className="modal__img" src={image.promiseResult.data} />
                            <button className="btn btn--med btn--primary btn--modal" onClick={this.downloadImage}>
                                    Download
                                </button>
                            </span>
                             : null)}
                {showNext ? <span className="modal__next" onClick={() => this.handleChange(this.props.activeIndex + 1)}><div className="modal__chevron-right"></div></span> : null}
            </Modal>
        )
    }

    getCurrentImage() {
        const { images, activeIndex } = this.props;
        return images[activeIndex];
    }
}

export { PaperworkEntryImageList }



// WEBPACK FOOTER //
// ./src/modules/paperwork-entry/components/PaperworkEntryImageList.js